import { useModulePermission } from '@sdx/b2o-fe-tools';

type UseGesPermissionProps = {
  accessToken: string | null;
  baseUrl: string;
  siteCode?: string;
};

type GesPermissionState = {
  isChecking: boolean;
  hasAccess: boolean | null;
};

const GES_MODULE = 'ges';

export const useGesPermission = ({
  accessToken,
  baseUrl,
  siteCode,
}: UseGesPermissionProps): GesPermissionState => {
  const { permissions, isLoading, hasError, canExecute } = useModulePermission(GES_MODULE, {
    baseUrl,
    accessToken: accessToken ?? undefined,
    siteCode: siteCode ?? undefined,
  });

  if (!canExecute || isLoading) {
    return { isChecking: true, hasAccess: null };
  }

  if (hasError || !permissions) {
    return { isChecking: false, hasAccess: false };
  }

  return { isChecking: false, hasAccess: permissions.canRead };
};
